export default {
  BusinessStockDistributionRatio: {
    header: {
      spuCode: 'Product Code',
      spuName: 'Product Name',
      skuCode: 'SKU',
      supportWarehouseCode: 'Supply Warehouse Code',
      supportWarehouseName: 'Supply Warehouse Name',
      categoryId: 'Product Category',
      receiveWarehouseCode: 'Receiving Warehouse Code',
      receiveWarehouseName: 'Receiving Warehouse Name',
    },

    commodityDistribution: 'Product Allocation',
    batchAllocation: 'Batch Allocation',

    table: {
      categoryName: 'Product Category',
      spuCode: 'Product Code',
      spuName: 'Product Name',
      skuCode: 'SKU',
      supportTypeCode: 'Supply Warehouse Type',
      supportCode: 'Supply Warehouse Code',
      supportName: 'Supply Warehouse Name',
      warehouseStructuralQty: 'Warehouse Structure Ratio',
      qty: 'Product Bin Ratio',
      receiveTypeCode: 'Receiving Warehouse Type',
      receiveCode: 'Receiving Warehouse Code',
      receiveName: 'Receiving Warehouse Name',
      lastUpdateName: 'Operator',
      lastUpdateDate: 'Operating Time',

    }
  }
};
